import { FormlyFieldConfig } from '@ngx-formly/core';
import { Offer } from 'app/services/offers/offer.model';
import { DealTypeOptions } from 'app/deal/deal-type-options';


export class RingDealFormFields {

  aprField = {
    className: 'ring-deal-column',
    fieldGroup: [
      {
        key: 'offer.apr',
        type: 'number',
        templateOptions: {
          label: 'APR',
          ngxMask: {
            suffix: ' %'
          },
          attributes: {
            'data-cy': 'offer-apr-input'
          },
          required: true
        },
        validation: {
          show: true,
        }
      }
    ]
  };

  factorField = {
    className: 'ring-deal-column',
    fieldGroup: [
      {
        key: 'offer.factor',
        type: 'number',
        templateOptions: {
          label: 'Factor',
          attributes: {
            'data-cy': 'offer-factor-input'
          },
          required: true
        },
        validation: {
          show: true,
        }
      }
    ]
  };

  interestField = {
    className: 'ring-deal-column',
    fieldGroup: [
      {
        key: 'offer.interestRate',
        type: 'number',
        templateOptions: {
          label: 'Interest',
          ngxMask: {
            suffix: ' %'
          },
          attributes: {
            'data-cy': 'offer-interest-input'
          },
          required: true
        },
        validation: {
          show: true,
        }
      }
    ]
  };

  factoringOfferFields = {
    className: 'ring-deal-column ring-deal-column-padding',
    fieldGroup: [
      {
        fieldGroupClassName: 'ring-deal-row',
        fieldGroup: [
          {
            className: 'ring-deal-column',
            fieldGroup: [
              {
                key: 'offer.advanceRate',
                type: 'number',
                templateOptions: {
                  label: 'Advance Rate',
                  ngxMask: {
                    suffix: ' %'
                  },
                  min: 20,
                  max: 99,
                  attributes: {
                    'data-cy': 'offer-advance-rate-input'
                  },
                  required: true
                },
                validation: {
                  show: true,
                }
              }
            ]
          },
          {
            className: 'ring-deal-column ring-deal-column-padding',
            fieldGroup: [
              {
                key: 'offer.commission',
                type: 'currency',
                templateOptions: {
                  label: 'Commission',
                  attributes: {
                    'data-cy': 'offer-commission-input'
                  },
                  required: true
                },
                validation: {
                  show: true,
                }
              }
            ]
          }
        ]
      },
      {
        fieldGroupClassName: 'ring-deal-row',
        fieldGroup: [
          {
            className: 'ring-deal-column',
            fieldGroup: [
              {
                key: 'offer.term',
                type: 'number',
                templateOptions: {
                  label: 'Contract Duration',
                  ngxMask: {
                    suffix: ' mo.'
                  },
                  attributes: {
                    'data-cy': 'offer-term-input'
                  },
                  required: true
                },
                validation: {
                  show: true,
                }
              }
            ]
          },
          {
            className: 'ring-deal-column ring-deal-column-padding',
            fieldGroup: [
              {
                key: 'offer.originationFee',
                type: 'number',
                templateOptions: {
                  label: 'Origination Fee',
                  ngxMask: {
                    suffix: ' %'
                  },
                  attributes: {
                    'data-cy': 'offer-origination-fee-input'
                  },
                }
              }
            ]
          }
        ]
      },
      {
        fieldGroupClassName: 'ring-deal-row',
        fieldGroup: [
          {
            className: 'ring-deal-column',
            fieldGroup: [
              {
                key: 'offer.minPurchaseFee',
                type: 'number',
                templateOptions: {
                  label: 'Min Purchase Fee',
                  ngxMask: {
                    suffix: ' %'
                  },
                  attributes: {
                    'data-cy': 'offer-min-purchase-fee-input'
                  },
                  min: 0,
                  max: 99,
                  required: true
                },
                validation: {
                  show: true,
                }
              }
            ]
          },
          {
            className: 'ring-deal-column ring-deal-column-padding',
            fieldGroup: [
              {
                key: 'offer.points',
                type: 'number',
                templateOptions: {
                  label: 'Points',
                  ngxMask: {
                    suffix: ' pts.'
                  },
                  attributes: {
                    'data-cy': 'offer-points-input'
                  },
                  required: true
                },
                validation: {
                  show: true,
                }
              }
            ]
          }
        ]
      },
      {
        fieldGroupClassName: 'ring-deal-row',
        fieldGroup: [
          {
            className: 'ring-deal-column',
            fieldGroup: [
              {
                key: 'offer.paymentTerm',
                type: 'select',
                templateOptions: {
                  label: 'Payment Term',
                  options: [
                    { label: 'Net 15', value: 'net 15' },
                    { label: 'Net 30', value: 'net 30' },
                    { label: 'Net 40', value: 'net 40' },
                    { label: 'Net 50', value: 'net 50' },
                    { label: 'Net 60', value: 'net 60' },
                    { label: 'Net 70', value: 'net 70' },
                    { label: 'Net 80', value: 'net 80' },
                    { label: 'Net 90', value: 'net 90' },
                    { label: 'Net 90+', value: 'net 90+' }
                  ],
                  attributes: {
                    'data-cy': 'offer-payment-term-input'
                  },
                }
              }
            ]
          },
          {
            className: 'ring-deal-column ring-deal-column-padding',
            fieldGroup: [
              {
                key: 'deal.lenderIdentifier',
                type: 'text',
                templateOptions: {
                  label: 'Lender Identifier',
                  attributes: {
                    'data-cy': 'deal-lender-identifier-input'
                  },
                }
              }
            ]
          }
        ]
      },
      {
        fieldGroupClassName: 'ring-deal-row',
        fieldGroup: [
          {
            className: 'ring-deal-column',
            fieldGroup: [
              {
                key: 'offer.type',
                type: 'select',
                templateOptions: {
                  label: 'Offer Type',
                  options: [
                    { label: 'Hard', value: 'hard' },
                    { label: 'Soft', value: 'soft' },
                    { label: 'Prequalified', value: 'prequal' },
                    { label: 'Referral', value: 'referral' }
                  ],
                  attributes: {
                    'data-cy': 'offer-type-input'
                  },
                  required: true
                },
                validation: {
                  show: true,
                }
              }
            ]
          }
        ]
      }
    ],
  };

  constructor() {}

  getRegularOfferFields(offer: Offer) {
    return   {
      className: 'ring-deal-column ring-deal-column-padding',
      fieldGroup: [
        {
          fieldGroupClassName: 'ring-deal-row',
          fieldGroup: [
            {
              className: 'ring-deal-column',
              fieldGroup: [
                {
                  key: 'offer.amount',
                  type: 'currency',
                  templateOptions: {
                    label: 'Amount',
                    attributes: {
                      'data-cy': 'offer-amount-input'
                    },
                    required: true
                  },
                  validation: {
                    show: true,
                  }
                }
              ]
            },
            {
              className: 'ring-deal-column ring-deal-column-padding',
              fieldGroup: [
                {
                  key: 'offer.payback',
                  type: 'currency',
                  templateOptions: {
                    label: 'Payback',
                    attributes: {
                      'data-cy': 'offer-payback-input'
                    },
                    required: true
                  },
                  validation: {
                    show: true,
                  }
                }
              ]
            }
          ]
        },
        {
          fieldGroupClassName: 'ring-deal-row',
          fieldGroup: [
            offer.apr ? this.aprField : offer.factor ? this.factorField : this.interestField,
            {
              className: 'ring-deal-column ring-deal-column-padding',
              fieldGroup: [
                {
                  key: 'offer.commission',
                  type: 'currency',
                  templateOptions: {
                    label: 'Commission',
                    attributes: {
                      'data-cy': 'offer-commission-input'
                    },
                    required: true
                  },
                  validation: {
                    show: true,
                  }
                }
              ]
            }
          ]
        },
        {
          fieldGroupClassName: 'ring-deal-row',
          fieldGroup: [
            {
              className: 'ring-deal-column',
              fieldGroup: [
                {
                  key: 'offer.points',
                  type: 'number',
                  templateOptions: {
                    label: 'Points',
                    ngxMask: {
                      suffix: ' pts.'
                    },
                    attributes: {
                      'data-cy': 'offer-points-input'
                    },
                    required: true
                  },
                  validation: {
                    show: true,
                  }
                }
              ]
            },
            {
              className: 'ring-deal-column ring-deal-column-padding',
              fieldGroup: [
                {
                  key: 'offer.numPayments',
                  type: 'number',
                  templateOptions: {
                    label: 'Number of Payments',
                    attributes: {
                      'data-cy': 'offer-num-payments-input'
                    },
                  }
                }
              ]
            }
          ]
        },
        {
          fieldGroupClassName: 'ring-deal-row',
          fieldGroup: [
            {
              className: 'ring-deal-column',
              fieldGroup: [
                {
                  key: 'offer.paymentFrequency',
                  type: 'select',
                  templateOptions: {
                    label: 'Payment Frequency',
                    attributes: {
                      'data-cy': 'offer-payment-frequency-input'
                    },
                    options: [
                      { label: 'Daily', value: 'daily' },
                      { label: 'Semi-Weekly', value: 'semiweekly' },
                      { label: 'Weekly', value: 'weekly' },
                      { label: 'Bi-Weekly', value: 'biweekly' },
                      { label: 'Semi-Monthly', value: 'semimonthly' },
                      { label: 'Monthly', value: 'monthly' },
                      { label: 'Bi-Monthly', value: 'bimonthly' }
                    ]
                  }
                }
              ]
            },
            {
              className: 'ring-deal-column ring-deal-column-padding',
              fieldGroup: [
                {
                  key: 'offer.paymentAmount',
                  type: 'currency',
                  templateOptions: {
                    label: 'Payment Amount',
                    attributes: {
                      'data-cy': 'offer-payment-amount-input'
                    },
                  }
                }
              ]
            }
          ]
        },
        {
          fieldGroupClassName: 'ring-deal-row',
          fieldGroup: [
            {
              className: 'ring-deal-column',
              fieldGroup: [
                {
                  key: 'offer.term',
                  type: 'number',
                  templateOptions: {
                    label: 'Term',
                    ngxMask: {
                      suffix: ' mo.'
                    },
                    attributes: {
                      'data-cy': 'offer-term-input'
                    },
                    required: true
                  },
                  validation: {
                    show: true,
                  }
                }
              ]
            },
            {
              className: 'ring-deal-column ring-deal-column-padding',
              fieldGroup: [
                {
                  key: 'offer.originationFee',
                  type: 'number',
                  templateOptions: {
                    label: 'Origination Fee',
                    ngxMask: {
                      suffix: ' %'
                    },
                    attributes: {
                      'data-cy': 'offer-origination-fee-input'
                    },
                  }
                }
              ]
            }
          ]
        },
        {
          fieldGroupClassName: 'ring-deal-row',
          fieldGroup: [
            {
              className: 'ring-deal-column',
              fieldGroup: [
                {
                  key: 'offer.position',
                  type: 'number',
                  templateOptions: {
                    label: 'Position',
                    attributes: {
                      'data-cy': 'offer-position-input'
                    },
                  }
                }
              ]
            },
            {
              className: 'ring-deal-column ring-deal-column-padding',
              fieldGroup: [
                {
                  key: 'offer.netFundedAmount',
                  type: 'currency',
                  templateOptions: {
                    label: 'Net Funded Amount',
                    attributes: {
                      'data-cy': 'offer-net-funded-amount-input'
                    },
                  }
                }
              ]
            }
          ]
        },
        {
          fieldGroupClassName: 'ring-deal-row',
          fieldGroup: [
            {
              className: 'ring-deal-column',
              fieldGroup: [
                {
                  key: 'deal.lenderIdentifier',
                  type: 'text',
                  templateOptions: {
                    label: 'Lender Identifier',
                    attributes: {
                      'data-cy': 'deal-lender-identifier-input'
                    },
                  }
                }
              ]
            },
            {
              className: 'ring-deal-column ring-deal-column-padding',
              fieldGroup: [
                {
                  key: 'offer.type',
                  type: 'select',
                  templateOptions: {
                    label: 'Offer Type',
                    options: [
                      { label: 'Hard', value: 'hard' },
                      { label: 'Soft', value: 'soft' },
                      { label: 'Prequalified', value: 'prequal' },
                      { label: 'Referral', value: 'referral' }
                    ],
                    attributes: {
                      'data-cy': 'offer-type-input'
                    },
                    required: true
                  },
                  validation: {
                    show: true,
                  }
                }
              ]
            }
          ]
        },
        {
          fieldGroupClassName: 'ring-deal-row',
          fieldGroup: [
            {
              className: 'ring-deal-column',
              fieldGroup: [
                {
                  key: 'offer.notes',
                  type: 'textarea',
                  templateOptions: {
                    label: 'Notes',
                    rows: 4,
                    attributes: {
                      'data-cy': 'offer-notes-input'
                    },
                  }
                }
              ]
            }
          ]
        },
      ],
    };
  }

  getRingDealFields(category: string | null, offer: Offer, teamLenderUsers: { label: string, value: number }[]): FormlyFieldConfig[] {
    return [
      {
        fieldGroupClassName: 'ring-deal-row',
        fieldGroup: [
          {
            className: 'ring-deal-column',
            fieldGroup: [
              {
                key: 'deal.loan_product_lender.name',
                type: 'text',
                templateOptions: {
                  label: 'Lender',
                  attributes: {
                    'data-cy': 'lender-input',
                  },
                  disabled: true
                }
              },
              {
                key: 'deal.loan_product.category.name',
                type: 'text',
                templateOptions: {
                  label: 'Product',
                  attributes: {
                    'data-cy': 'product-input',
                  },
                  disabled: true
                }
              },
              {
                key: 'offer.amount',
                type: 'currency',
                templateOptions: {
                  label: 'Deal Amount',
                  attributes: {
                    'data-cy': 'deal-amount-input',
                  },
                  required: true
                },
                validation: {
                  show: true,
                }
              },
              {
                key: 'deal.dateClosed',
                type: 'datepicker',
                templateOptions: {
                  label: 'Date Closed',
                  attributes: {
                    'data-cy': 'date-closed-input',
                  },
                  required: true
                },
                validation: {
                  show: true,
                }
              },
              {
                key: 'deal.created',
                type: 'datepicker',
                templateOptions: {
                  label: 'Date Started',
                  attributes: {
                    'data-cy': 'date-started-input',
                  },
                  required: true
                },
                validation: {
                  show: true,
                }
              },
              {
                key: 'deal.closedBy',
                type: 'select',
                templateOptions: {
                  label: 'Closed By',
                  options: teamLenderUsers,
                  attributes: {
                    'data-cy': 'closed-by-input'
                  }
                }
              },
              {
                key: 'deal.type',
                type: 'select',
                templateOptions: {
                  label: 'Deal Type',
                  options: DealTypeOptions,
                  attributes: {
                    'data-cy': 'deal-type-input'
                  }
                }
              }
            ]
          },
          category === 'factoring' ? this.factoringOfferFields : this.getRegularOfferFields(offer)
        ]
      }
    ];
  }

  getFields(category: string | null, offer: Offer, teamLenderUsers: { label: string, value: number }[]) {
    return this.getRingDealFields(category, offer, teamLenderUsers);
  }
}
